   document.addEventListener('DOMContentLoaded', function () {

  if (window.innerWidth <= 1090) {
        setInterval(function () {
          var barras = document.querySelectorAll('.barra-de-anuncio');

          barras.forEach(function (barra) {
            var msgs = barra.querySelectorAll('.barra-msg');
            if (msgs.length > 0) {
              var activeIndex = 0;

              msgs.forEach(function (msg, idx) {
                if (msg.classList.contains('active')) {
                  activeIndex = idx;
                  msg.classList.remove('active');
                }
              });

              var nextIndex = (activeIndex + 1) % msgs.length;
              msgs[nextIndex].classList.add('active');
            }
          });
        }, 1700);
      }
    });